import { validateStepsByValidationResults } from 'sos-eservice-common/js/Redux/Reducers/validation.helpers';
import { QualityRegisterOrderProps } from './QualityOrder.types';
import { QualityRegisterOrderGlobals } from '../../models';
import { ValidationState } from 'sos-common/js/commonTypes';

export function getInitialState(props: QualityRegisterOrderProps) {
  const {
    orderId,
    model,
    translations,
    qualityRegistries,
    validationResults,
    homePageUrl,
    thankYouPageUrl,
  } = props;

  const registers = {
    qualityRegistries
  };
  const globals = {
    homePageUrl,
    thankYouPageUrl,
    orderId,
    translations,
    shouldShowDelete: !!orderId,
    currentStep: 1,
    hasHitSummary: false,
    isSending: false
  } as Partial<QualityRegisterOrderGlobals>;

  const initialValidationState: ValidationState = {
    validationResults,
    fullValidationResults: validationResults,
    stepValidationMap: {
      0: {
        isValid: false,
        stepId: 0
      },
      1: {
        isValid: false,
        stepId: 1
      }
    },
    touchedFields: []
  };

  const validationState = validateStepsByValidationResults(initialValidationState);

  return {
    formModel: model,
    globals,
    registers,
    files: {},
    validationState
  }
}
